import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-06527ceb"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "ExperienceSelector"
};
var _hoisted_2 = {
  "class": "modal"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, " choose your experience ", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "summary"
  }, [/*#__PURE__*/_createTextVNode("The \"Full Intro\" is an immersive "), /*#__PURE__*/_createElementVNode("i", null, "voice interaction"), /*#__PURE__*/_createTextVNode(" that helps tune your AIVitar to you and "), /*#__PURE__*/_createElementVNode("i", null, "enhances all future conversations"), /*#__PURE__*/_createTextVNode(" you have with your AIVitar. If you have the time, we think you might enjoy it.")], -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "black"
  }, "(Around 15 Min.)", -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "recommended"
  }, "Recommended For Best Experience", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "or"
  }, " or ", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "yellow"
  }, "(3 minutes)", -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "recommended"
  }, "Recommended For Impatience ;)", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "fade"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("button", {
        "class": "select-avatar-button",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.immersive();
        })
      }, [_createTextVNode(" FULL INTRO "), _hoisted_5]), _hoisted_6, _hoisted_7, _createElementVNode("button", {
        "class": "select-avatar-button select-avatar-button--purple",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.quick();
        })
      }, [_createTextVNode(" QUICKSTART "), _hoisted_8]), _hoisted_9])];
    }),
    _: 1
  })]);
}